module.exports = __webpack_public_path__ + "img/image-12.de8d9f8d.webp";